<template>
  <v-card v-if="loading">
    <v-progress-circular
      class="loader"
      indeterminate
      color="#e12011"
    ></v-progress-circular>
  </v-card>
  <v-card v-else>
    <v-card-title>
      <span class="headline">
        Editar alarma {{ alarm.plc_name }} {{ alarm.hmi_alarm_id }} ({{ alarm.alarm_id }})
      </span>
    </v-card-title>
    <v-card-text class="pt-4">
      <v-form
        ref="form"
        v-model="valid"
      >
        <v-container>
          <v-row>
            <v-col cols="12" class="custom-col">
              <v-select
                :items="notificationTypes"
                v-model="alarm.notification_type_id"
                label="Tipo de notificación"
                item-text="description"
                item-value="notification_type_id"
                required
              ></v-select>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" class="custom-col">
              <v-textarea
                v-model="alarm.text_description"
                label="Descripción de la alarma"
                required
                hide-details
                rows="1"
                auto-grow
              ></v-textarea>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" class="custom-col">
              <v-combobox
                v-model="alarm.emails"
                label="Emails para notificar"
                placeholder="Pulsa Enter para agregar"
                multiple
                chips
                clearable
                hide-details
              ></v-combobox>
            </v-col>
          </v-row>

        </v-container>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        color="grey darken-1"
        text
        @click="cancel"
      >
        Cancelar
      </v-btn>
      <v-btn
        color="green darken-1"
        text
        :disabled="!valid"
        @click="submit"
      >
        Guardar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "AlarmForm",

  data() {
    return {
      loading: true,
      valid: false,
      alarm: {
        text_description: "",
        notification_type_id: 1,
        emails: [],
      },
    };
  },

  props: {
    incomingAlarm: Object,
    notificationTypes: Array,
  },

  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        this.close();
      }
    },

    close() {
      this.$emit("close", {
        ...this.alarm,
        emails: this.alarm.emails.join(","),
      });
    },


    cancel() {
      this.$emit("cancel");
    },
  },

  watch: {
    incomingAlarm: {
      immediate: true,
      handler(newVal) {
        this.alarm = {
          ...newVal,
          emails: newVal.emails ? newVal.emails.split(",").map(e => e.trim()) : [],
        };
        this.$nextTick(() => {
          this.$refs.form?.resetValidation();
          this.loading = false;
        });
      },
    },
  },
};
</script>

<style scoped>
.custom-col {
  padding-top: 0px;
  padding-bottom: 0px;
}

.loader {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
}
</style>
